module.exports = __webpack_public_path__ + "static/media/hero-collectibles.ea11f7ec.png";